/**
 * Solanaland
 *
 * Author: Phia Nasol
 * Company: Digiteer Inc.
 *
 * https://www.digiteer.digital/
 *
 */

export const navigateTo = (route: string): void => {
  if (route) {
    location.href = route;
  } else {
    console.warn("Route not defined.");
  }
};

export const navigateToIf = (condition: boolean, route: string, fallbackRoute = null): void => {
  if (condition) {
    location.href = route;
  } else {
    if (fallbackRoute) {
      location.href = fallbackRoute;
    } else {
      console.warn("No fallback route speficied");
      return;
    }
  }
};

export const navigateToUnless = (condition: boolean, route: string, fallbackRoute = null): void => {
  if (!condition) {
    location.href = route;
  } else {
    if (fallbackRoute) {
      location.href = fallbackRoute;
    } else {
      console.warn("No fallback route speficied");
      return;
    }
  }
};
